import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

/**
 * Slider component
 */
export default class Gallery extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Gallery',
    refs: ['slider', 'prev', 'next', 'pagination', 'thumbs[]'],
    options: {
      pagination: {
        type: String,
        default: 'bullets',
      },
      spaceBetween: {
        type: Number,
        default: 0,
      },
      slidesPerView: {
        type: Number,
        default: 0,
      },
    },
  };

  /**
   *
   */
  mounted() {
    this.slider = new Swiper(this.$refs.slider, {
      modules: [Pagination],
      slidesPerView: 'auto',
      grabCursor: true,
      pagination: {
        clickable: true,
        el: this.$refs.pagination,
        type: this.$options.pagination,
      },
    });
  }

  /**
   * Click on thumbs to change sliders
   * @param {object} props
   * @param {Event} props.event
   * @param {number} props.index
   */
  onThumbsClick({ event, index }) {
    event.preventDefault();
    this.slider.slideTo(index);
    this.updateActiveThumbs(index);
  }

  /**
   * Active thumbs when clicked
   * @param {number} index
   */
  updateActiveThumbs(index) {
    this.$refs.thumbs.forEach((item, i) => {
      item.classList.toggle('is-active', i === index);
    });
  }
}
